import { render, staticRenderFns } from "./CheatingRules.vue?vue&type=template&id=72b9f344&scoped=true&"
import script from "./CheatingRules.vue?vue&type=script&lang=js&"
export * from "./CheatingRules.vue?vue&type=script&lang=js&"
import style0 from "./CheatingRules.vue?vue&type=style&index=0&id=72b9f344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9f344",
  null
  
)

export default component.exports